/**
 * Request Cache: prevents multiple request of same resources/apis
 */
export const requestsCache = {};

 /**
  * Data Cache: stores responses from API Data requests and Custom Tables, enables sync lookup for less re-renders
  */
export const dataCache = {};

/**
 * Function that wraps an async request and makes sure it's only executed once
 * and returns the response data in a promise
 * @param request asynchronous function that loads request
 * @param cacheKey key to store/retrieve data from cache
 * @returns Promise<result>
 */
export async function requestWithCache(request, cacheKey) {
    if (!cacheKey) {
        // Skip caching since no key was provided
        return await request();
    }
    if (dataCache[cacheKey] !== undefined) {
        // Retrieve data from caching
        return dataCache[cacheKey];
    }
    // execute request and cache the response
    requestsCache[cacheKey] = requestsCache[cacheKey] || request();
    dataCache[cacheKey] = await requestsCache[cacheKey];
    return dataCache[cacheKey];
}
